<template>
    <b-card class="mb-3">
        <div v-if="!isModal" class="mx-0 mb-4 row">
            <h4>
                {{ $t('menu.createMoneyPlacement') }}
            </h4>
            <div class="ml-auto">
                <button type="button" class="close" @click="onClose" :title="$t('general.cancel')">
                    <close-icon title="" />
                </button>
            </div>
        </div>

        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>

        <b-alert variant="success" :show="success">
            {{ alert }}
        </b-alert>

        <b-form @submit.prevent="create">
            <b-form-group :label="$t('menu.moneyPlacements')" label-cols-sm="3">
                <b-form-select :options="types" v-model="taskType" @input="setSum(model.ccmOption)" required></b-form-select>
            </b-form-group>

            <b-form-group :label="$t('kkm.label')" label-cols-sm="3">
                
                <multiselect v-model="model.ccmOption" 
                    :options="ccmIds" label="text" 
                    :placeholder="$t('general.enterValue')"
                    :disabled="isModal"
                    :allow-empty="false" 
                    @input="setSum"/>

            </b-form-group>

            <b-form-group :label="$t('report.sum')" label-cols-sm="3"> 
                <b-input v-model="model.amount" :state="isNumber(model.amount)" required/>
            </b-form-group>

            <b-form-row class="justify-content-end mx-0">
                <b-button type="button" @click="onClose" variant="danger" class="mr-2">
                    <close-icon />&nbsp;{{ $t('general.cancel') }}
                </b-button>

                <b-button type="submit" variant="success" :disabled="!isNumber(model.amount)">
                    <plus-icon />&nbsp;{{ $t('general.create') }}
                </b-button>
            </b-form-row>

        </b-form>
    </b-card>
</template>

<script>
/* eslin-disable */
import AppData from '@/utils/appdata';
import { normalizeArrayOfCcm } from '@/utils/utils';
import { constants } from 'crypto';

const TaskTypes = {
    Withdraw: 'Withdraw',
    Deposit: 'Deposit'
};

export default {
    name: 'CreateMoneyPlacement',
    mixins: [ AppData ],
    props: {
        onClose: Function,
        taxpayer: Object,
        controlCashMachine: Object,
        isModal: Boolean
    },
    mounted() {
        if (this.controlCashMachine == null) {
            this.getControlCashMachines();
        }
        else {
            this.controlCashMachines.push(this.controlCashMachine);
            const ccmIds = this.$miscUtil.generateSelectList(this.controlCashMachines, 'id', 'factoryNumber');

            this.model.ccmOption = ccmIds[0];
        }
    },
    data () {
        return {
            taskType: null,
            model: {
                ccmOption: null,
                amount: null  
            },
            controlCashMachines: [],
            ccmIds: [],
            success: false
        }
    },
    computed: {
        types() {
            return [
                { value: null, text: this.$t('general.select') },
                { value: TaskTypes.Withdraw, text: this.$t(`moneyPlacement.collection`) },
                { value: TaskTypes.Deposit, text: this.$t(`moneyPlacement.replenishment`) }
            ]
        }
    },
    methods: {
        async getControlCashMachines() {
            const data = { dealerId: this.taxpayer.id };
                   
            try {
                const rawCcms = await this.$request.sendRequestAsync(this, this.$appConfig.apiUrls.kkm.getAll, data);

                this.controlCashMachines = normalizeArrayOfCcm(rawCcms);

                this.ccmIds = this.$miscUtil.generateSelectList(this.controlCashMachines, 'id', 'factoryNumber');
            } 
            catch(error) {
                this.handlerError(error);
            }
        },
        setSum(option) {
            if(option == null || this.taskType == null)
                return;

            if (this.taskType === TaskTypes.Withdraw) {
                const ccm = this.controlCashMachines.find(x => x.id == option.value);
            
                if (ccm != null) {
                    this.model.amount = ccm.cashAmount;
                }
            }
            else {
                this.model.amount = null;
            }
            
        },
        async create() {
            this.hideAlert();

            if (this.model.ccmOption == null) {
                this.alert = this.$i18n.t('kkm.required');
                this.showAlert = true;

                return;
            }

            const body = {
                ccmId: this.model.ccmOption.value,
                amount: this.model.amount,
                type: this.taskType
            };
            
            try {
                await this.$request
                    .sendRequestAsync(
                        this,
                        this.$appConfig.apiUrls.moneyPlacement.create,
                        body
                    );

                this.alert = this.$i18n.t(`moneyPlacement.${this.taskType.toLowerCase()}TaskHasBeenCreated`);

                this.success = true;
            }
            catch(error) {
                this.handlerError(error);
            }
        },
        handlerError(error) {
            console.error(`Some error has been coruped: ${error}`);

            const errorToShow = typeof(error) == 'number'
                ? error
                : 'unknownError';

            this.displayAlert(errorToShow);
        },
        isNumber(value) {
            return /^[0-9]+\.?(?:\d{1,2})?$/.test(value);
        }
    }
}

</script>